import utils from '@/mixins/utils.js'

export const dataFields = {
  Data: {
    callback: (item) => {
      let dados = JSON.parse(item.dados)
      return dados != null ? utils.methods.formatDate(dados.dt_acao) : ''
    },
  },
  Ação: {
    callback: (item) => {
      let dados = JSON.parse(item.dados)
      return dados.tp_acao
    },
  },
  Tipo: 'tipo',
}

export const infoHtml = ``
